import type { WorkflowType } from '@td/core';
import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../stores';

export function workupGuard(flow: WorkflowType | Array<WorkflowType>, loginUrl = '/login'): CanActivateFn {
  return () => {
    const authStore = inject(AuthStore);
    const router = inject(Router);
    const types = Array.isArray(flow) ? flow : [flow];
    const workflow = authStore.workflowType();

    return authStore.accessToken() && workflow && types.includes(workflow) ? true : router.parseUrl(loginUrl);
  };
}

export const notAuthGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const accessToken = authStore.accessToken();
  const workflow = authStore.workflowType();

  if (!accessToken || !workflow) return true;

  switch (workflow) {
    case 'CTW':
      return router.parseUrl('/ctw');
    case 'LTS':
      return router.parseUrl('/lts');
    case 'PARKING':
      return router.parseUrl('/citation/parking-incident');
    case 'TOWING':
      return router.parseUrl('/citation/towing-incident');
    case 'TRAFFIC':
    case 'MISDEMEANOR':
    case 'ARMED_FORCES_TRAFFIC':
    case 'FEDERAL':
    case 'FIRE_ENFORCEMENT':
      return router.parseUrl('/citation');
  }
};
